import { RoleLevel, RolesString } from "./guards/roles"

const constants = {
  profiles: [
    {
      name: RolesString.ADMIN,
      key: 'admin',
      role: RoleLevel.ADMIN
    },
    {
      name: RolesString.PARTNER,
      key: 'partner',
      role: RoleLevel.PARTNER
    },
    {
      name: RolesString.ANALYST,
      key: 'analyst',
      role: RoleLevel.ANALYST
    },
  ],
  genres: [
    {
      name: 'Masculino',
      key: 'MASCULINO'
    },
    {
      name: 'Feminino',
      key: 'FEMININO'
    },
    {
      name: 'Prefiro não dizer',
      key: 'NI'
    },
  ],
  reports: [
    {
      name: 'analyst.assesments_simple',
      value: 1
    },
    {
      name: 'analyst.assesments_extended',
      value: 2
    }
  ],
  province: [
    {
      acronym: 'AC',
      name: 'Acre',
      value: 12
    },
    {
      acronym: 'AL',
      name: 'Alagoas',
      value: 27
    },
    {
      acronym: 'AP',
      name: 'Amapá',
      value: 13
    },
    {
      acronym: 'AM',
      name: 'Amazonas',
      value: 16
    },
    {
      acronym: 'BA',
      name: 'Bahia',
      value: 29
    },
    {
      acronym: 'CE',
      name: 'Ceará',
      value: 23
    },
    {
      acronym: 'DF',
      name: 'Distrito Federal',
      value: 53
    },
    {
      acronym: 'ES',
      name: 'Espírito Santo',
      value: 32
    },
    {
      acronym: 'GO',
      name: 'Goiás',
      value: 52
    },
    {
      acronym: 'MA',
      name: 'Maranhão',
      value: 21
    },
    {
      acronym: 'MT',
      name: 'Mato Grosso',
      value: 51
    },
    {
      acronym: 'MS',
      name: 'Mato Grosso do Sul',
      value: 50
    },
    {
      acronym: 'MG',
      name: 'Minas Gerais',
      value: 31
    },
    {
      acronym: 'PA',
      name: 'Pará',
      value: 15
    },
    {
      acronym: 'PB',
      name: 'Paraíba',
      value: 25
    },
    {
      acronym: 'PR',
      name: 'Paraná',
      value: 41
    },
    {
      acronym: 'PE',
      name: 'Pernambuco',
      value: 26
    },
    {
      acronym: 'PI',
      name: 'Piauí',
      value: 22
    },
    {
      acronym: 'RN',
      name: 'Rio Grande do Norte',
      value: 24
    },
    {
      acronym: 'RS',
      name: 'Rio Grande do Sul',
      value: 43
    },
    {
      acronym: 'RR',
      name: 'Roraima',
      value: 14
    },
    {
      acronym: 'RO',
      name: 'Rondônia',
      value: 11
    },
    {
      acronym: 'RJ',
      name: 'Rio de Janeiro',
      value: 33
    },
    {
      acronym: 'SP',
      name: 'São Paulo',
      value: 35
    },
    {
      acronym: 'SC',
      name: 'Santa Catarina',
      value: 42
    },
    {
      acronym: 'SE',
      name: 'Sergipe',
      value: 28
    },
    {
      acronym: 'TO',
      name: 'Tocantins',
      value: 17
    },
  ],
  priority: [
    {
      name: 'Prioridade Baixa',
      value: 0
    },
    {
      name: 'Prioridade Média',
      value: 1
    },
    {
      name: 'Prioridade Alta',
      value: 2
    },
    {
      name: 'Urgente',
      value: 3
    },
  ],
}

const pagination = {
  pages: [15, 30, 50, 100]
}

export { constants, pagination }